// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"featured-in__wrapper1wH","header":"featured-in__headerulo","images":"featured-in__images3qk"};